define('features/error-404',[
  'jquery',
  'lib/getParameterByName',
  'lib/page-cache',
  'lib/util/zip',
  'lib/util/tda.config',
  'lib/services/offers-service',
  'lib/services/inventory-service',
  'lib/filtersFromVehicleId',
  'lib/transforms/offers.tmpl.common',
  'components/slicker',
  'txt!./inventory/inventory.results.cards.hbs',
  'disclaimers',
  'lib/transforms/inventory',
  'lib/util/debounce',
  'features/inventory/inventory-vehicle',
  'features/favorites',
  'responsive',
  'bat',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',
  'cookies',

  // side effect includes
  'lib/helpers/offer-bundle',
  'lazyload'
], function (
  $,
  getParameterByName,
  PageCache,
  zip,
  tdaConfig,
  offersFactory,
  inventoryService,
  filtersFromVehicleId,
  xformOffersCommon,
  Slicker,
  txtCards,
  disclaimersService,
  inventoryXform,
  debounce,
  InventoryVehicle,
  favorites,
  responsive,
  bat,
  blocks,
  pageLoad,
  anClicks,
  anAddContext,
  cookies
) {
  var __hasRtiDealer = cookies.getItem('dealer_code_rti') === 'true';
  var error404 = {

    firePageLoad: function (context) {
      var kmMetric;
      var pagename;
      var content_section = 'unavailable';
      var errorType = 'not-404';

      switch (context) {
        case 'generic':
          kmMetric = 'km-404-g';
          pagename = 'T:404:Generic';
          errorType = '404';
          content_section = 'Generic 404';
          break;
        case 'inventory_available':
          kmMetric = 'km-404-ia';
          pagename = 'T:404:Inventory Available';
          content_section = 'Inventory Available';
          break;
        case 'inventory_unavailable':
          kmMetric = 'km-404-iua';
          pagename = 'T:404:Inventory Unavailable';
          content_section = 'Inventory Unavailable';
          break;
        case 'offers_available':
          kmMetric = 'km-404-oa';
          pagename = 'T:404:Offer Available';
          content_section = 'Offer Available';
          break;
        case 'offers_unavailable':
          kmMetric = 'km-404-oua';
          pagename = 'T:404:Offer Unavailable';
          content_section = 'Offer Unavailable';
          break;
        default:
          break;
      }
      var self = this;
      self.content_section = content_section;
      /*
      var dataToAdd = {
        metrics: kmMetric,
        current_pagename: pagename
      };
      */
      // SPECIAL CASE, it appears that inventory_unavailable is the only case with content_section.
      /*
      if (content_section) {
        //dataToAdd.content_section = content_section;
      }
      */
      var $scope = $('#error404FW');
      anAddContext(
        $scope
      );
      anClicks($scope);

      try {
        pageLoad(
          $scope,
          blocks.keyMetrics(kmMetric),
          blocks.errorBlock(errorType, pagename),
          blocks.sectionBlock(self.content_section)
        );
      } catch (error) {
        console.error('firePageLoad ERROR', error);// eslint-disable-line no-console
      }
    },

    addGradientBG: function () {
      $('.error404-fw').addClass('fw-gradient');
    },

    showAdditionalItems: function (title) {
      $('.additional-items-title').html(title);
      $('.additional-items-title').show();
      $('.additional-items').show();
    },

    updateAdditionalCta: function (str, url) {
      $('#additionalCTA').html(str);
      if (url) {
        $('#additionalCTA').attr('href', url);
      }
    },

    updateBackground: function (tag, cta, ctaUrl) {
      $('.error404-tag').html(tag);
      var ctaBtn = $('.error404-btn');
      ctaBtn.html(cta);
      ctaBtn.addClass('btn-active');
      ctaBtn.attr('href', ctaUrl);
      ctaBtn.attr('target', '_self');
    },

    drawBackground: function (context, title, src, msg, tag, cta, ctaUrl, ctaColor, ctaTarget) {
      var self = this;
      self.pageContext = context;
      if (title === '') {
        title = '&nbsp;';
      }
      $('.error404-title').html(title);
      // BG IMAGE. TODO: add resize handling, store the 'last_hero_image'.
      if (responsive() !== 'sm') {
        var img = '<img src="' + src + '"/>';
        $('.fw-center').html(img);
        if (self.pageContext !== 'generic') {
          $('.fw-center img').addClass('default-img');
        }
      } else {
        $('#mobHeroImg').attr('src', src);
        if (self.pageContext !== 'generic') {
          $('.mob-hero-img').addClass('default-img');
        }
      }
      self.last_hero_image = src; // see resize.
      $('.error404-msg').html(msg);
      $('.error404-tag').html(tag);
      if (cta) {
        var ctaBtn = $('.error404-btn');
        ctaBtn.html(cta);
        if (ctaColor) {
          var btnClass = '';
          switch (ctaColor) {
            case 'grey':
              btnClass = 'btn-grey';
              break;
            case 'grey-dark':
              btnClass = 'btn-grey-dark';
              break;
            default:
              btnClass = 'btn-primary';
              break;
          }
          ctaBtn.addClass(btnClass);
        }
        ctaBtn.addClass('btn-active');
        ctaBtn.attr('href', ctaUrl);
        if (ctaTarget) {
          ctaBtn.attr('target', ctaTarget);
        }
      }
    },

    makeSlicker: function (context, slides, container, slideItem) {
      container.append(slides);
      var stripper = new Slicker({
        $slider: container,
        slickOptions: {
          mobileFirst: true,
          slide: slideItem,
          slidesToShow: 3,
          dots: false,
          arrows: false,
          centerMode: false,
          centerPadding: '0px',
          autoplay: false,

          desktop: {
            arrows: true,
            dots: true
          },
          tablet: {},
          initFunction: function () {
            $('img.lazy-v', '.offer-cards-slider').lazy({
              afterLoad: function ($el) {
                $el.css({ visibility: 'visible' });
              }
            });
          }
        }
      });
    },
    favListeners: function () {
      var $favButton = $('.favorite-button', this.$$additionalItemsContainer);
      if (__hasRtiDealer) {
        $favButton.hide();
      } else {
        $favButton.each(function () {
          var $this = $(this);
          favorites.markFav($this);
          $this.on('click', function favClick(e) {
            e.preventDefault();
            favorites.addRemove($this);
          });
        });
      }
    },
    drawOfferCards: function (data) {
      var self = this;
      xformOffersCommon(data, true)
        .then(function (response) {
          var formattingObj = {
            items: response,
            numFound: response.length
          };
          var $template = $('#template-offer-card');
          var handlebarsHTML = Handlebars.hcompile($template.html(), formattingObj);
          var cards = $(handlebarsHTML);
          var slider = $('.offer-cards-slider');
          self.makeSlicker('offer', cards, slider, '.card');
          slider.show();
          self.favListeners();
          self.addOfferContext(response);
        });
    },
    addOfferContext: function (offers) {
      var self = this;
      var $scope = $('.additional-items');
      anAddContext(
        $scope,
        blocks.sectionBlock(self.content_section),
        blocks.offerListBlock({
          count: offers.length,
          layout: 'strip'
        }),
        blocks.seriesBlock({
          series_code: self.series_code
        })
      );
      // offers context for each
      offers.forEach(function eachOfferCtx(offer) {
        anAddContext(
          $('a[href$="' + offer.id + '"]').parent('div.card-content'),
          blocks.offerBlock(offer)
        );
      });
      anClicks($scope);
    },
    drawOffer404: function (offerId) {
      // OFFER DETAIL PAGES WILL REDIRECT AND PASS OFFER ID PARAM
      var self = this;
      self.addGradientBG();
      var pSeries = offerId.split('_')[0];
      $('.offer-strip-title').html('');
      $('.offer-strip-title').hide();
      // reparent the offer strip:
      var oStrip = $('#component-offers-strip').detach();
      $('#additional-items-container').append(oStrip);
      var testing = !!getParameterByName('una');// TODO:REMOVE
      var heroSrc = '/assets/img/vehicles/' + pSeries + '/default-offer-detail.png';
      // MISCELLANEOUS OFFER USE CASE:
      if (pSeries.indexOf('misc') !== -1 || pSeries === 'miscellaneous') {
        self.miscellaneousOffer = true;
        heroSrc = '/assets/img/404/hero-vehicles-404-full-2.png';
      }
      var msg = self.miscellaneousOffer ? self.i18n.no_offer_msg.replace('%1', '') : self.i18n.no_offer_msg.replace('%1', self.seriesMap[pSeries].series_name);
      $('.error404-msg').html(msg);
      var initialtag = 'Looking...';
      var title = ''; // NO TITLE FOR suggested offers.

      self.drawBackground('offer', title, heroSrc, msg, initialtag);
      var tda = tdaConfig.tda.code;
      var zc = zip.getCookiedDefaultFallback();

      self.series_code = pSeries;

      // CHECK FOR RELATED OFFERS, BASED ON SERIES:
      var options = {
        tdaCode: tda,
        zipCode: zc,
        series: pSeries,
        pageSize: 6
      };

      var offersService = offersFactory(tdaConfig.offers.r2_api_key);
      offersService.offers().all(options)
        .then(function (response) {
          if (response.totalOffers > 0 && !testing) { // TODO:REMOVE TESTING una. (unavailable)
            // SHOW SERIES OFFERS
            var tag = '';
            var lang = self.i18n.lang;
            if (lang === 'en') {
              tag = self.i18n.tag_series_offers.replace('%1', response.totalOffers).replace('%2', self.seriesMap[pSeries].series_name);
            } else if (lang === 'es') {
              // BAT-3871 - Conill updates for Spanish
              if (response.totalOffers > 1) {
                tag = self.i18n.tag_series_offers.replace('%1', response.totalOffers).replace('%2', 'ofertas disponibles').replace('%3', self.seriesMap[pSeries].series_name);
              } else {
                tag = self.i18n.tag_series_offers.replace('%1', '1').replace('%2', 'oferta disponible').replace('%3', self.seriesMap[pSeries].series_name);
              }
            } else {
              tag = self.i18n.tag_series_offers.replace('%1', response.totalOffers).replace('%2', self.seriesMap[pSeries].series_name);
            }

            var cta = self.i18n.cta_explore_series_offers.replace('%1', self.seriesMap[pSeries].series_name);
            var url = '/' + tdaConfig.site.context_url + '/offers/' + pSeries + '/';
            var additionalTitle = self.i18n.additional_offers_series_title.replace('%1', self.seriesMap[pSeries].series_name);
            self.updateAdditionalCta(self.i18n.cta_explore_offers, url);
            setTimeout(function () { // BAT25-419 - added timeout
              self.showAdditionalItems(additionalTitle);
            }, 500);
            self.updateBackground(tag, cta, url);
            setTimeout(function () { // BAT25-419 - added timeout
              self.drawOfferCards(response.offerBundle.offers);
            }, 650);
            self.firePageLoad('offers_available');
          } else {
            // FETCH OFFERS , WITHOUT SERIES PARAM.
            var options2 = {
              tdaCode: tda,
              zipCode: zc,
              pageSize: 6
            };
            var offersService2 = offersFactory(tdaConfig.offers.r2_api_key); // USE API KEY IN META.
            var offersReq2 = offersService.offers().all(options2)
              .then(function (response) {
                var tag = self.miscellaneousOffer ? '' : self.i18n.tag_no_series_offers.replace('%1', self.seriesMap[pSeries].series_name); //
                var cta = self.miscellaneousOffer ? self.i18n.cta_explore_all_offers : self.i18n.cta_explore_all_offers.replace('%1', self.seriesMap[pSeries].series_name);
                var url = '/' + tdaConfig.site.context_url + '/offers/';
                additionalTitle = self.i18n.additional_offers_title;
                self.updateAdditionalCta(self.i18n.cta_explore_offers, url);
                setTimeout(function () { // BAT25-419 - added timeout
                  self.showAdditionalItems(additionalTitle);
                }, 500);
                self.updateBackground(tag, cta, url);
                setTimeout(function () { // BAT25-419 - added timeout
                  self.drawOfferCards(response.offerBundle.offers);
                }, 650);
                self.firePageLoad('offers_unavailable');
              });
          }
        });
    },
    addInventoryContext: function (cards) {
      // console.log('addInventoryContext cards:', cards);
      var self = this;
      var $scope = $('.additional-items');
      anAddContext(
        $scope,
        blocks.sectionBlock(self.content_section)
      );

      var count = 0;
      cards.items.forEach(function eachOfferCtx(item) {
        var match =  $('.card .card-content a[href*="' + item.id + '"]');
        match.attr('data-linktext', 'Vehicle Details'); // ADDS LINK TEXT, USED IN links.block.
        anAddContext(
          match,
          blocks.seriesBlock(item),
          blocks.listItemBlock(count)
        );
        count++;
      });
      anClicks($scope);
    },
    drawInventoryCards: function (uiObject) {
      var self = this;
      // tack on another data-layer item
      var listItemIndexStart = uiObject.displayingRecordsCount - 8;
      for (var i = 0; i < uiObject.items.length; i++) {
        uiObject.items[i].dataLayer.list_item_index = listItemIndexStart.toString();
        listItemIndexStart++;
      }
      var __tmplCards = Handlebars.compile(txtCards);
      var handlebarsHTML = __tmplCards(uiObject);
      handlebarsHTML = InventoryVehicle.Disclaimers.replaceDisclaimerTags(handlebarsHTML);
      var $newItems = $(handlebarsHTML);
      var slider = $('#isotope-inventory');
      self.makeSlicker('inventory', $newItems, slider, '.card');
      slider.show();
      disclaimersService.msrpMpgDigits('#isotope-inventory');


      // BAT-2522: manage series names that are exceedlingly long.
      var yams = $('.year-and-model.textfit-one-line');
      yams.each(function (index, item) {
        if ($(item).find('.font-bold').html().length >= 40) {
          $(item).css('font-size', '14px');
        }
      });
      // ADD CONTEXT HERE.
      self.addInventoryContext(uiObject)
    },

    drawInventory: function (response) {
      var self = this;
      try {
        self.uiObject = self.handleResponse(response);
        this.drawInventoryCards(self.uiObject);
      } catch (error) {
        console.error(' ::: drawInventory ERROR', error);
      }
    },

    handleResponse: function (resolvedData) {
      var self = this;
      var start = this.uiObject ? this.uiObject.displayingRecordsCount : 0;
      var total = resolvedData.body.response.numFound;
      var stats = resolvedData.body.response.stats;
      disclaimersService.addLocalDisclaimers();
      InventoryVehicle.Disclaimers.createDisclaimersMap(resolvedData.body.response.disclaimers);

      var xformedCards = inventoryXform({
        data: resolvedData
      });
      var uiObject = {
        i18n: self.i18n,
        siteContext: tdaConfig.site.context_url,
        items: xformedCards,
        stats: stats,
        numFound: total,
        displayingRecordsCount: start + xformedCards.length
      };
      this.uiObject = uiObject;
      return uiObject;
    },

    drawInventory404: function (inventoryId, series) {
      var self = this;
      // INVENTORY DTEAIL PAGES WILL REDIRECT AND PASS INVENTORY ID AND SERIES PARAMS.
      var msg = self.i18n.no_inventory_msg.replace('%1', self.seriesMap[series].series_name);
      var errorTitle = ''; // NO TITLE FOR suggested inventory.
      var heroSrc = '/assets/img/vehicles/' + series + '/default-offer-detail.png';
      var initialtag = 'Looking ... ';
      self.drawBackground('inventory', errorTitle, heroSrc, msg, initialtag);

      // CHECK FOR SERIES INVENTORY:
      self._filters = filtersFromVehicleId(getParameterByName('vehicleid')); // TODO: use this in inventory-detail.
      // console.log('FILTERS ', self._filters);
      var testing = !!getParameterByName('una'); // TODO:remove.
      // LOGIC BORROWED AND MODIFIED FROM iventory-vehicle.
      PageCache.on('inventory.results', function (cache) {
        // console.log(' numFound: ', cache.body.response.numFound, '\nresp:',cache.body.response);
        // cache.body.response.numFound = 0;//TESTING ZERO RESULTS.
        var tag;
        var cta;
        var ctaUrl;
        if (cache.body.response.numFound && !testing) {
          self.addGradientBG();
          // console.log(' ::: SHOLD DRAW INVENTORY STRIP ', cache.body.response.numFound);
          var additionalTitle = self.i18n.additional_inventory_title_series.replace('%1', self.seriesMap[series].series_name);
          setTimeout(function () { // BAT25-392 - added timeout - BAT25-419 increased to 350
            self.showAdditionalItems(additionalTitle);
          }, 500);
          cta = self.i18n.cta_search_series_inventory.replace('%1', self.seriesMap[series].series_name);
          tag = self.i18n.tag_series_inventory.replace('%1', self.seriesMap[series].series_name);
          var ctaUrl = '/' + tdaConfig.site.context_url + '/inventory/results/?series=' + series;
          self.updateBackground(tag, cta, ctaUrl);
          self.updateAdditionalCta(self.i18n.cta_explore_inventory, ctaUrl);
          setTimeout(function () { // BAT25-419 - added timeout
            self.drawInventory(cache);
          }, 650);
          self.firePageLoad('inventory_available');
        } else {
          tag = self.i18n.tag_no_series_inventory;
          cta = self.i18n.cta_explore_all_inventory;
          ctaUrl = '/' + tdaConfig.site.context_url + '/inventory/';
          self.updateBackground(tag, cta, ctaUrl);
          self.firePageLoad('inventory_unavailable');
        }
      });

      var defaultOptions = {
        brand: 'TOY',
        filter: {},
        fields: [],
        pagesize: 9,
        pagestart: 0,
        facetfields: [],
        sortfield: 'MSRP',
        sortorder: 'ASC',
        group: 'true',
        groupmode: 'full',
        mode: 'content'
      };
      var defaultFilter = {
        region: [tdaConfig.inventory.region_code], // shouldnt we actually just default to 600?
        series: [series],
        year: [self._filters.year[0]],
        dealers: []
      };

      var invRequest = $.extend({}, defaultOptions, {});
      invRequest.filter = $.extend({}, defaultFilter, {});

      var cacheId = 'inventory.results'; // inventory vehicle uses a different approach for this, see requestInventory.
      if (!PageCache.isPending(cacheId)) {
        PageCache.maybeSet(cacheId, inventoryService.inventory().getInventory(invRequest));
      }
    },

    drawGeneric404: function (config) {
      var self = this;
      var errorTitle = self.i18n.error_title;
      var heroSrc = '/assets/img/404/hero-vehicles-404-full-2.png';
      var msg = self.i18n.generic_msg;
      var tag = self.i18n.tag_generic;

      // When there's no CTA configured via the Generic 404 page tools DCR,
      // we still want to render page w/out a CTA.
      if ($.isEmptyObject(config.ctas)) {
        self.drawBackground('generic', errorTitle, heroSrc, msg, tag, null, null, null, null);
      } else {
        var outcomeString = config.ctas.CTAs.OutcomeCTAs.split('|')[0];
        var cta = outcomeString;
        var director = config.ctas.CTAs.OutcomeCTAs.split('|')[1];
        var path = '';
        var ctaUrl;

        switch (director) {
          case 'deal-builder':
            ctaUrl = 'http://www.toyota.com/configurator';
            break;
          case 'custom':
            cta = config.ctas.CTAs.CustomCTATitle;
            ctaUrl = self.fixDestinationUrl(config.ctas.CTAs.CustomCTADestination);
            break;
          default:
            path = director;
            ctaUrl = '/' + tdaConfig.site.context_url + '/' + path + '/';
            break;
        }

        var customColor = config.ctas.CTAs.CTAcolors;
        var target = config.ctas.CTAs.CustomLinkTarget;
        self.drawBackground('generic', errorTitle, heroSrc, msg, tag, cta, ctaUrl, customColor, target); // FIX OTHER CALLS TO drawBackground with these params.
      }
      self.firePageLoad('generic');
    },

    // REMOVE 'sites' FROM CUSTOM CTAs, REPLACE WITH site_context
    fixDestinationUrl: function (url) {
      var customUrl = url;
      var customUrlArr = customUrl.split('/');

      if (customUrlArr[1] == 'sites') {
        customUrlArr.splice(0, 3); // Drop the first 3 items from array ('', 'sites', 'TDA')
        customUrlArr.unshift('/' + tdaConfig.site.context_url);
      }
      var finalUrl = customUrlArr.join('/');
      return finalUrl;
    },

    init: function (config) {
      bat.util.loader.showLoader();
      var self = this;
      self.$additionalItemsContainer = $('#additional-items-container');
      self.i18n = config.i18n;
      self.lastBreakpoint = '';
      // console.log(' ::: CONFIG: typeof', typeof config, 'config:', config);
      // console.log(' ::: CONFIG: i18n:', self.i18n);
      var inventoryId = getParameterByName('vehicleid'); // this is for inventory detail redirect
      var offerId = getParameterByName('offerid'); // this is for offer detail redirect
      var series = getParameterByName('series');
      PageCache.await('series.map').then(function (seriesMap) {
        self.seriesMap = seriesMap;
        if (offerId && window.location.pathname.indexOf('suggested-offers') >= 0) {
          self.drawOffer404(offerId);
        } else if (inventoryId && window.location.pathname.indexOf('suggested-inventory') >= 0) {
          self.drawInventory404(inventoryId, series);
        } else {
          self.drawGeneric404(config);
        }
      });

      $(window).on('resize', debounce(function () {
        if (responsive() !== self.lastBreakpoint && self.last_hero_image) {
          $('.error404-btn').hide();
          // We need the correct hero image based on breakpoint:
          if (responsive() !== 'sm') {
            $('.fw-center').html('<img src="' + self.last_hero_image + '"/>');
            if (self.pageContext !== 'generic') {
              $('.fw-center img').addClass('default-img');
            }
            $('#mobHeroImg').attr('src', ''); // clear
            $('.error404-btn').show();
          } else {
            $('#mobHeroImg').attr('src', self.last_hero_image);
            if (self.pageContext !== 'generic') {
              $('.mob-hero-img').addClass('default-img');
            }
            $('.fw-center').html('<img src=""/>');
            $('.error404-btn').show();
          }
        }
        self.lastBreakpoint = responsive();
      }, 500));
    },
  };

  return error404;
});

